import React from 'react'
import * as S from './styled'

const MainLayout = ({children}) => {
  return (
    <S.MainContainer>{children}</S.MainContainer>
  )
}

export default MainLayout